module.exports = __webpack_public_path__ + "img/question.563000cc.png";